const strengths = [
  {
    number: '01',
    icon: 'ri-flashlight-line',
    title: '빠른 대응 시스템',
    summary: '요청 즉시 배정, 긴급 상황도 24시간 대응',
    details: [
      '간병 요청 접수 후 최단 시간 내 간병인 배정',
      '24시간 긴급 대응 체계 운영',
      '전담 코디네이터가 처음부터 끝까지 관리',
      '실시간 진행 상황 안내 및 소통',
    ],
    img: 'https://readdy.ai/api/search-image?query=Korean%20professional%20coordinator%20working%20at%20modern%20clean%20desk%20with%20phone%20and%20computer%2C%20fast%20response%20customer%20service%2C%20bright%20office%20environment%20with%20green%20accent%20colors%2C%20white%20walls%2C%20professional%20atmosphere%2C%20photorealistic%20high%20quality&width=560&height=360&seq=kc_str1&orientation=landscape',
  },
  {
    number: '02',
    icon: 'ri-user-heart-line',
    title: '고객 맞춤형 서비스',
    summary: '환자 상태와 요구에 딱 맞는 1:1 매칭',
    details: [
      '환자 상태·병원 환경·보호자 요구 사전 파악',
      '경력·전문성·성격까지 고려한 간병인 매칭',
      '서비스 기간 중 지속적인 만족도 모니터링',
      '변경 요청 시 신속한 재배정 지원',
    ],
    img: 'https://readdy.ai/api/search-image?query=Korean%20caregiver%20and%20elderly%20patient%20in%20warm%20comfortable%20hospital%20room%2C%20personalized%20one-on-one%20care%2C%20gentle%20interaction%2C%20soft%20green%20and%20white%20interior%2C%20natural%20window%20light%2C%20compassionate%20professional%20service%2C%20photorealistic%20high%20quality&width=560&height=360&seq=kc_str2&orientation=landscape',
  },
  {
    number: '03',
    icon: 'ri-money-dollar-circle-line',
    title: '업계 최저 수수료',
    summary: '일 4,000원 · 최소 10,000원 / 최대 100,000원',
    details: [
      '업계 최저 수준 수수료 일 4,000원 적용',
      '최소 10,000원, 최대 100,000원으로 하한·상한 책정',
      '기본 간병인 1명 기준, 추가 시 1인당 10,000원 부과',
      '숨겨진 추가 비용 없는 투명한 요금 체계',
    ],
    img: 'https://readdy.ai/api/search-image?query=Clean%20modern%20financial%20document%20with%20Korean%20won%20currency%20symbol%2C%20transparent%20pricing%20concept%2C%20minimalist%20white%20and%20green%20design%2C%20professional%20business%20document%20on%20desk%2C%20soft%20lighting%2C%20photorealistic%20high%20quality&width=560&height=360&seq=kc_str3&orientation=landscape',
  },
  {
    number: '04',
    icon: 'ri-file-shield-2-line',
    title: '간병보험 서류 발급',
    summary: '간병 완료 후 보험 청구 서류 원스톱 처리',
    details: [
      '간병 완료 즉시 보험 청구용 서류 발급',
      '각 보험사 양식에 맞는 정확한 서류 작성',
      '복잡한 행정 절차를 전문가가 대신 처리',
      '향후 간병 매칭 앱으로 더욱 편리하게 발전 예정',
    ],
    img: 'https://readdy.ai/api/search-image?query=Korean%20professional%20office%20worker%20preparing%20insurance%20documents%20at%20clean%20white%20desk%2C%20organized%20paperwork%2C%20green%20accent%20stationery%2C%20bright%20modern%20office%2C%20professional%20document%20processing%20service%2C%20photorealistic%20high%20quality&width=560&height=360&seq=kc_str4&orientation=landscape',
  },
];

export default function IntroStrengths() {
  return (
    <section className="w-full py-20" style={{ backgroundColor: '#f4faf8' }}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <p className="text-xs font-semibold tracking-widest uppercase mb-3" style={{ color: '#2E7D6B' }}>OUR STRENGTHS</p>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900">코리아케어러스만의 강점</h2>
          <p className="text-sm text-gray-400 mt-3">고객이 코리아케어러스를 선택하는 이유</p>
        </div>

        <div className="space-y-10">
          {strengths.map((s, i) => (
            <div
              key={i}
              className={`flex flex-col ${i % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-8 items-center bg-white rounded-2xl overflow-hidden border border-gray-100`}
            >
              {/* Image */}
              <div className="w-full lg:w-[45%] flex-shrink-0" style={{ height: '280px' }}>
                <img
                  src={s.img}
                  alt={s.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              {/* Content */}
              <div className="flex-1 p-8 lg:p-10">
                <div className="flex items-center gap-3 mb-4">
                  <span
                    className="text-3xl font-black"
                    style={{ color: 'rgba(46,125,107,0.15)' }}
                  >
                    {s.number}
                  </span>
                  <div
                    className="w-9 h-9 flex items-center justify-center rounded-xl"
                    style={{ backgroundColor: 'rgba(46,125,107,0.1)' }}
                  >
                    <i className={`${s.icon} text-base`} style={{ color: '#2E7D6B' }}></i>
                  </div>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{s.title}</h3>
                <p className="text-sm font-semibold mb-5" style={{ color: '#2E7D6B' }}>{s.summary}</p>
                <ul className="space-y-2.5">
                  {s.details.map((d, j) => (
                    <li key={j} className="flex items-start gap-2.5">
                      <div className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5">
                        <i className="ri-check-line text-xs" style={{ color: '#2E7D6B' }}></i>
                      </div>
                      <span className="text-xs leading-relaxed text-gray-500">{d}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        {/* App development notice */}
        <div
          className="mt-12 rounded-2xl p-8 flex flex-col md:flex-row items-center gap-6"
          style={{ background: 'linear-gradient(135deg, #0d2b24 0%, #1a4a3a 100%)' }}
        >
          <div className="w-14 h-14 flex items-center justify-center rounded-2xl flex-shrink-0" style={{ backgroundColor: 'rgba(111,207,184,0.2)' }}>
            <i className="ri-smartphone-line text-2xl" style={{ color: '#6fcfb8' }}></i>
          </div>
          <div className="flex-1 text-center md:text-left">
            <h4 className="text-base font-bold text-white mb-1">간병 매칭 앱 개발 예정</h4>
            <p className="text-xs leading-relaxed" style={{ color: 'rgba(255,255,255,0.6)' }}>
              코리아케어러스는 현재 간병보험 서류 발급 서비스를 중심으로 운영하며, 향후 간병인과 환자를 더욱 빠르고 편리하게 연결하는
              <strong className="text-white"> 전용 간병 매칭 앱</strong>을 개발할 예정입니다. 더 나은 서비스로 찾아뵙겠습니다.
            </p>
          </div>
          <div
            className="flex-shrink-0 px-5 py-2.5 rounded-full text-xs font-semibold whitespace-nowrap"
            style={{ backgroundColor: 'rgba(111,207,184,0.2)', color: '#6fcfb8', border: '1px solid rgba(111,207,184,0.3)' }}
          >
            Coming Soon
          </div>
        </div>
      </div>
    </section>
  );
}
